import {
  Box,
  Tooltip,
  useTheme,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
} from '@mui/material';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import InfoIcon from '@mui/icons-material/Info';

import { calculateAge } from '@shared/helpers/calculateAge';
import InfoValueRow from '@shared/components/InfoValueRow';
import PaymentDetails from '@shared/components/PaymentDetails';

const PriceDetails = ({
  storagePassengers,
  cardData,
  total,
  isPayment,
  totalUsd,
  currencyValue,
  hasCharges,
}) => {
  const theme = useTheme();

  const passengers =
    storagePassengers?.clientesCotizados?.clienteCotizacion || [];

  const title = isPayment && (
    <Grid item xs={12}>
      <Typography
        sx={{
          width: '100%',
          color: '#000',
          fontWeight: 700,
          fontSize: { xs: '18px', md: '20px' },
          pb: 1,
          lineHeight: 1,
        }}
      >
        Detalle de tu pago
      </Typography>
    </Grid>
  );

  const summaryStyles = {
    px: 0,
    minHeight: 32,
    mb: isPayment ? 0 : 1,
    '&.Mui-expanded': {
      minHeight: 32,
      mb: isPayment ? 0 : 1,
    },
    '& .MuiAccordionSummary-content': {
      margin: 0,
      alignItems: 'center',
    },
  };

  const titleStyles = {
    fontWeight: isPayment ? 600 : 700,
    color: isPayment ? 'gray' : '#000',
    fontSize: isPayment
      ? { xs: '16px', sm: '18px' }
      : { xs: '18px', sm: '20px' },
  };

  return (
    <Box>
      {title}

      <Accordion
        elevation={0}
        disableGutters
        sx={{
          boxShadow: 'none',
          '&::before': {
            bgcolor: 'white',
          },
          '&.Mui-expanded': {
            margin: 0,
          },
        }}
      >
        <AccordionSummary sx={summaryStyles} expandIcon={<ExpandMoreIcon />}>
          <Typography sx={titleStyles}>Precio por pasajero</Typography>
        </AccordionSummary>

        <AccordionDetails sx={{ p: '8px 0px 8px 0px' }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 1,
            }}
          >
            {passengers.map((el, index) => {
              const age = calculateAge(el.fechaNacimiento);
              const paxLabel = `Pasajero ${index + 1}`;

              let tooltipText = '';
              if (age >= 70 && age < 75)
                tooltipText = 'Pasajero mayor a 70 años';
              if (age >= 75) tooltipText = 'Pasajero mayor a 75 años';

              const label = tooltipText ? (
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  {paxLabel}
                  <Tooltip title={tooltipText}>
                    <InfoIcon
                      sx={{
                        fontSize: 18,
                        color: theme.tertiary,
                        ml: 0.75,
                      }}
                    />
                  </Tooltip>
                </span>
              ) : (
                paxLabel
              );

              return (
                <Box key={+index} width="100%">
                  <InfoValueRow
                    label={label}
                    value={el?.pax_price_USD}
                    isPrice
                    isInUSD
                  />
                </Box>
              );
            })}
          </Box>
        </AccordionDetails>
      </Accordion>

      <PaymentDetails
        cardData={cardData}
        total={total}
        isInUSD={!isPayment}
        totalUsd={totalUsd}
        currencyValue={currencyValue}
        productType="assist"
        hasCharges={hasCharges}
      />
    </Box>
  );
};

export default PriceDetails;
